// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1JssW","productName":"Table_productName__2HTbp"};